export const CARD_TREATMENT_ENUM = {
  NONE: 'none',
  BOX_SHADOW: 'boxShadow',
  BORDER: 'border',
};

export const ALIGNMENT_ENUM = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
};

export const CARDS_PER_ROW_ENUM = {
  ONE: '1',
  TWO: '2',
  THREE: '3',
  FOUR: '4',
};
